




































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class VideoPlayer extends Vue {
  /**
   * Source url for a video element
   */
  @Prop({ required: true, type: String })
  private src!: string;
}
